import Fade from '@mui/material/Fade'
import { ReactElement, useEffect, useState } from 'react'
import AvatarAndNameDisplay from './AvatarAndNameDisplay'

const FADE_TIMEOUT = 1000

type FadeUserDisplayProps = {
  children: ReactElement<typeof AvatarAndNameDisplay>
  rotationInterval: number
}

const FadeUserDisplay: React.FC<FadeUserDisplayProps> = ({ children, rotationInterval }) => {
  const [fade, setFade] = useState(false)

  useEffect(() => {
    setFade(true)
    const timer = setTimeout(() => {
      setFade(false)
    }, rotationInterval - FADE_TIMEOUT)
    return () => clearTimeout(timer)
  }, [rotationInterval])

  return (
    <Fade in={fade} timeout={FADE_TIMEOUT}>
      <div>{children}</div>
    </Fade>
  )
}

export default FadeUserDisplay
